import { render } from "./PetiteVoie.vue?vue&type=template&id=7212ead9&scoped=true&ts=true"
import script from "./PetiteVoie.vue?vue&type=script&lang=ts"
export * from "./PetiteVoie.vue?vue&type=script&lang=ts"

import "./PetiteVoie.vue?vue&type=style&index=0&id=7212ead9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7212ead9"]])

export default __exports__